import React, { useState, useEffect, useCallback } from "react";
import Tree from "rc-tree";
import "rc-tree/assets/index.css";
import { Dropdown } from "react-bootstrap";
import { createAuthFetch } from "../utils/authFetch";
import { typeTreeCache } from "../services/typeTreeCache";

//let treeDataCache = null;
//const treeDataCache = {};

const ensureKeys = (nodes) => {
  if (!Array.isArray(nodes)) return [];
  return nodes.map((node, idx) => {
    const safeChildren = Array.isArray(node.children)
      ? ensureKeys(node.children)
      : [];
    return {
      ...node,
      key: node.key ?? node.id ?? `node_${idx}`,
      children: safeChildren,
    };
  });
};

const TypeTreeDropdown = ({ selectedType, onChange }) => {
  const [hasData, setHasData] = useState(true);
  const [open, setOpen] = useState(false);
  const [treeData, setTreeData] = useState([]);
  const [selectedKey, setSelectedKey] = useState(null);
  const [selectedTitle, setSelectedTitle] = useState(null);
  const authFetch = createAuthFetch();

  useEffect(() => {
    const dbuid = localStorage.getItem("dbuid");
    if (!dbuid) return;

    if (Array.isArray(typeTreeCache[dbuid])) {
      if (typeTreeCache[dbuid].length === 0) {
        setHasData(false);
        return;
      }

      setTreeData(typeTreeCache[dbuid]);
      return;
    }

    const fetchTypes = async () => {
      try {
        const res = await authFetch("/amz-api/filters/types?dbuid=" + dbuid);
        const result = await res.json();

        if (result.statusCode === 200) {
          const raw = result.data;

          if (!raw || (Array.isArray(raw) && raw.length === 0)) {
            typeTreeCache[dbuid] = [];  // ✅ КЕШУЄМО EMPTY
            setHasData(false);
            return;
          }

          const data = Array.isArray(raw) ? raw : [raw];
          const ensured = ensureKeys(data);

          typeTreeCache[dbuid] = ensured;
          setTreeData(ensured);

        } else {
          console.error("Unexpected response:", result);
        }
      } catch (err) {
        console.error("Failed to fetch type tree:", err);
      }
    };

    fetchTypes();
  }, []);


  useEffect(() => {
    if (!selectedType) {
      setSelectedKey(null);
      setSelectedTitle(null);
    }
  }, [selectedType]);

  const handleSelect = useCallback(
    (selectedKeys, { node }) => {
      setSelectedKey(node.key);
      setSelectedTitle(node.title);

      onChange?.({
        typeTitle: node.title,
        ids: node.ids,
      });

      setOpen(false);
    },
    [onChange]
  );

  if (!hasData) return null;

  return (
    <Dropdown show={open} onToggle={() => setOpen(!open)}>
      <Dropdown.Toggle variant="secondary">
        {selectedTitle || "Types"}
      </Dropdown.Toggle>
      <Dropdown.Menu style={{ minWidth: "250px" }} className="dropdown-menu-dark">
        <Tree
          treeData={treeData}
          selectable
          selectedKeys={selectedKey ? [selectedKey] : []}
          onSelect={handleSelect}
          virtual
          height={300}
          itemHeight={24}
        />
      </Dropdown.Menu>
    </Dropdown>
  );
};

/*function normalizeTreeData(data) {
  return data.map((node) => ({
    ...node,
    children: Array.isArray(node.children)
      ? normalizeTreeData(node.children)
      : [],
  }));
}*/
export default React.memo(TypeTreeDropdown);
